/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Component } from 'react';
import _ from 'underscore';

import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { sortFeaturedPowerUps } from 'app/src/components/PowerUpDirectory/HomePage';
import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
const t = recupWithHelpers('directory_home');
class DirectoryHomeComponent extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Home';

    this.prototype.render = t.renderable(function () {
      return t.div(() =>
        t.div('.directory-content-body', function () {
          t.div('.directory-heading-wrapper', () =>
            t.h2(() => t.formatText('featured-power-ups')),
          );
          t.div('.directory-featured-powerups.js-featured-power-ups-container');
          t.div('.directory-heading-wrapper', () =>
            t.h2(() => t.formatText('integrations')),
          );
          t.div('.directory-featured-powerups.js-integrations-container');
          t.div('.directory-heading-wrapper', () =>
            t.h2(() => t.formatText('essential-power-ups')),
          );
          t.div(
            '.directory-featured-powerups.js-essential-power-ups-container',
          );
          t.div('.directory-heading-wrapper', () =>
            t.h2(() => t.formatText('other-great-power-ups')),
          );
          return t.div(
            '.directory-featured-powerups.js-other-power-ups-container',
          );
        }),
      );
    });
  }
}

DirectoryHomeComponent.initClass();

// @ts-expect-error
interface DirectoryHomeView extends BaseDirectoryView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubviews: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentPage: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  directoryView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  essentialPlugins: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  featuredPlugins: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  integrations: any;
}

class DirectoryHomeView extends BaseDirectoryView {
  // @ts-expect-error TS(2416): Property 'initialize' in type 'DirectoryHomeView' ... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ directoryView, currentPage }: any) {
    this.directoryView = directoryView;
    this.currentPage = currentPage;
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    return super.initialize(...arguments);
  }

  eventSource() {
    return 'boardDirectoryFeaturedScreen';
  }

  renderContent() {
    // @ts-expect-error TS(2769): No overload matches this call.
    return <DirectoryHomeComponent boardId={this.model.id} />;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPluginsByTags(tags: any) {
    return _.filter(this.directoryView.plugins, (plugin) =>
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      _.every(tags, (tag) => _.contains(plugin.get('tags'), tag)),
    );
  }

  getFeaturedPlugins() {
    const featuredPlugins = this.getPluginsByTags(['featured']);
    // eslint-disable-next-line @trello/enforce-variable-case
    const sortedPluginsJSON = sortFeaturedPowerUps(
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      _.map(featuredPlugins, (plugin) => plugin.toJSON()),
    );
    const sortedPlugins = _.map(sortedPluginsJSON, (pluginJSON) =>
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      _.find(featuredPlugins, (plugin) => plugin.id === pluginJSON.id),
    );
    return (this.featuredPlugins = sortedPlugins);
  }

  getEssentialPlugins() {
    return (
      this.essentialPlugins ??
      (this.essentialPlugins = this.getPluginsByTags(['essential']))
    );
  }

  getIntegrations() {
    if (this.integrations != null) {
      return this.integrations;
    }
    const integrations = this.getPluginsByTags(['integration']);
    return (this.integrations = integrations);
  }

  getOtherPowerUps() {
    const excludeFeaturedAndEssential = _.filter(
      this.directoryView.plugins,
      function (plugin) {
        return (
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          !_.contains(plugin.get('tags'), 'featured') &&
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          !_.contains(plugin.get('tags'), 'essential') &&
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          !_.contains(plugin.get('tags'), 'integration')
        );
      },
    );
    return _.sample(excludeFeaturedAndEssential, 12);
  }

  render() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.render(...arguments);
    const featuredPlugins = this.directoryView.filterUnavailablePlugins(
      this.getFeaturedPlugins(),
    );
    const essentialPlugins = this.directoryView.filterUnavailablePlugins(
      this.getEssentialPlugins(),
    );
    const integrations = this.directoryView.filterUnavailablePlugins(
      this.getIntegrations(),
    );
    const otherPlugins = this.directoryView.filterUnavailablePlugins(
      this.getOtherPowerUps(),
    );
    const enabledPlugins = this.directoryView.getEnabledPlugins();

    const listedPlugins = _.flatten([
      featuredPlugins,
      integrations,
      essentialPlugins,
      otherPlugins,
    ]);

    const featuredPluginItemSubviews = _.map(featuredPlugins, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Featured,
          currentPage: this.currentPage,
          plugin,
          directoryView: this.directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id + '_featured',
      );
    });

    const essentialPluginItemSubviews = _.map(essentialPlugins, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Featured,
          currentPage: this.currentPage,
          plugin,
          directoryView: this.directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id + '_essential',
      );
    });

    const integrationItemSubviews = _.map(integrations, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Featured,
          currentPage: this.currentPage,
          plugin,
          directoryView: this.directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id,
      );
    });

    const otherPluginItemSubviews = _.map(otherPlugins, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Description,
          currentPage: this.currentPage,
          plugin,
          directoryView: this.directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id,
      );
    });

    this.appendSubviews(
      featuredPluginItemSubviews,
      this.$el.find('.js-featured-power-ups-container'),
    );
    this.appendSubviews(
      essentialPluginItemSubviews,
      this.$el.find('.js-essential-power-ups-container'),
    );
    this.appendSubviews(
      integrationItemSubviews,
      this.$el.find('.js-integrations-container'),
    );
    this.appendSubviews(
      otherPluginItemSubviews,
      this.$el.find('.js-other-power-ups-container'),
    );

    const listedPowerUpsEnabled = _.intersection(
      _.map(listedPlugins, 'id'),
      _.map(enabledPlugins, 'id'),
    );

    this.directoryView.trackScreenEvent(
      this.eventSource(),
      {
        totalListed: listedPlugins.length,
        totalListedEnabled: listedPowerUpsEnabled.length,
        totalEnabled: enabledPlugins.length,
        allPowerUpsEnabled: _.map(enabledPlugins, 'id'),
      },
      listedPowerUpsEnabled,
    );

    return this;
  }
}

export { DirectoryHomeView };
